import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3f34ab52&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductsLoansCapturePoint: require('/home/ubuntu/nuxt/bonkers/releases/20231201105121/components/products/loans/capture-point.vue').default,ProductsHumanising: require('/home/ubuntu/nuxt/bonkers/releases/20231201105121/components/products/humanising.vue').default,ProductsMoreInfo: require('/home/ubuntu/nuxt/bonkers/releases/20231201105121/components/products/more-info.vue').default,SiteFeefo: require('/home/ubuntu/nuxt/bonkers/releases/20231201105121/components/site/feefo.vue').default})
